import { render } from "./Diamond.vue?vue&type=template&id=619bc272&scoped=true"
import script from "./Diamond.vue?vue&type=script&lang=js"
export * from "./Diamond.vue?vue&type=script&lang=js"

import "./Diamond.vue?vue&type=style&index=0&id=619bc272&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619bc272"]])

export default __exports__